import { create } from 'zustand'

interface BaseExperimentValue {
  value?: string
  isReady: boolean
}

interface ReadyExperimentValue extends BaseExperimentValue {
  value: string
  isReady: true
}

interface UndefinedExperimentValue extends BaseExperimentValue {
  isReady: false
  value: undefined
}

interface Experiments {
  [key: string]: ReadyExperimentValue | UndefinedExperimentValue
}

interface ExperimentStore {
  experiments: Experiments
  updateExperiments: (experiments: Experiments) => void
}

export const useExperimentStore = create<ExperimentStore>(set => ({
  experiments: {},
  updateExperiments: experiments => {
    set(state => ({
      experiments: {
        ...state.experiments,
        ...experiments
      }
    }))
  }
}))

export type { ReadyExperimentValue, UndefinedExperimentValue, Experiments }
